// libraries/components/src/components/upcoming-trips/services/itinerary-content-resolver.ts

import { traverse } from "./traverse";
import type { ItineraryContent } from "@jb-manage-trips/types/itinerary";

type ItineraryLabels = ItineraryContent & {
  messages: ItineraryContent["messages"];
  normal: ItineraryContent["submit"]["normal"];
  submit: ItineraryContent["submit"];
};

type TraversedItineraryData = {
  labels: ItineraryLabels;
};

/**
 * Port of Angular `itineraryComponentResolver`.
 *
 * Takes raw CMS data (Magnolia) for the itinerary component and returns
 * a normalized `content` object for the React view.
 */
export function itineraryComponentResolver(data: unknown): {
  content: ItineraryContent;
} {
  const traversedData = traverse(data) as TraversedItineraryData;

  return {
    content: {
      header: traversedData.labels.header,
      flightRoute: traversedData.labels.flightRoute,
      messages: {
        ...traversedData.labels.messages,
      },
      submit: {
        ...traversedData.labels.submit,
        normal: traversedData.labels.normal,
      },
      amenities: traversedData.labels.amenities,
    },
  };
}
